// A 5xx body can carry only { sentryId } (no message); its raw bodyText is JSON noise, so callers skip it.
export const isOpaqueError = (error) => {
  const body = error && error.body
  return !!(body && !body.message && body.sentryId)
}

export const errorRef = (error) => (isOpaqueError(error) ? ` (error id: ${error.body.sentryId})` : '')

export const withErrorRef = (error, text) => text + errorRef(error)

export const bodyTextOrRef = (error) =>
  isOpaqueError(error) ? withErrorRef(error, 'Something went wrong. Please try again.') : error.bodyText
